import queries from '@apis/queries';
import { useQuery } from '@tanstack/react-query';

function useShopRecommendedItems(shopId: string, itemId: string) {
  const { data } = useQuery(queries.recommendedItems.shop(shopId));
  const title = data?.title;
  const items = data?.items
    .filter((item) => item.shopItemId !== itemId);
  return { title, items };
}

export default useShopRecommendedItems;
